/**
 * 1.8.7 (D-1.8.7-1) — the small calendar's words: a cell shows a number, and says everything in its name —
 * "Tuesday, October 13: 4 Housekeeping visits, 1 event"; "Today, Saturday, October 10: nothing on this day".
 */
import type { TFunction } from 'i18next';
import { dayCounts, type CalLine, type DayCount } from '@shared/house-calendar';
import { lineWords } from './lineWords';

type Lang = 'en' | 'es';

/** A closed day and a holiday are a word in the cell ("Closed"), not a number. */
export const isWordCount = (c: DayCount) => c.category === 'closed' || c.category === 'holidays';

/** "4 Housekeeping visits", "1 event", "2 Housekeeping visits in pencil"; "Closed", "Holiday". */
export function countWords(c: DayCount, t: TFunction): string {
  if (isWordCount(c)) return t(`cal187.short.${c.category}`);
  return t(c.pencil ? 'cal187.count.pencil' : `cal187.count.${c.category}`, { count: c.count });
}

/** The cell's whole name: the day (with "Today" on today), then every count; a closed day and a holiday in full. */
export function cellName(dayWords: string, isToday: boolean, lines: readonly CalLine[], t: TFunction, lang: Lang): string {
  const whole = lines.filter((l) => l.category === 'closed' || l.category === 'holidays').map((l) => lineWords(l, t, lang));
  const counts = dayCounts(lines)
    .filter((c) => !isWordCount(c))
    .map((c) => countWords(c, t));
  const what = [...counts, ...whole].join(', ') || t('cal187.nothing');
  return t(isToday ? 'cal187.nameToday' : 'cal187.name', { day: dayWords, what });
}
